export const Professions: string[] = [
    "Accountant",
    "Actor",
    "Architect",
    "Astronomer",
    "Baker",
    "Banker",
    "Barista",
    "Bartender",
    "Biologist",
    "Blacksmith",
    "Botanist",
    "Carpenter",
    "Chef",
    "Chemist",
    "Chiropractor",
    "Civil Engineer",
    "Dentist",
    "Dietitian",
    "Doctor",
    "Economist",
    "Editor",
    "Electrician",
    "Farmer",
    "Fashion Designer",
    "Film Director",
    "Financial Analyst",
    "Firefighter",
    "Fisherman",
    "Fitness Trainer",
    "Florist",
    "Game Designer",
    "Graphic Designer",
    "Hairdresser",
    "Historian",
    "Hotel Manager",
    "Interpreter",
    "Journalist",
    "Jeweler",
    "Lawyer",
    "Librarian",
    "Linguist",
    "Makeup Artist",
    "Marketing Manager",
    "Mathematician",
    "Mechanic",
    "Meteorologist",
    "Musician",
    "Nurse",
    "Nutritionist",
    "Painter",
    "Paramedic",
    "Pharmacist",
    "Photographer",
    "Physicist",
    "Pilot",
    "Plumber",
    "Police Officer",
    "Politician",
    "Professor",
    "Programmer",
    "Psychiatrist",
    "Psychologist",
    "Real Estate Agent",
    "Scientist",
    "Social Worker",
    "Software Developer",
    "Statistician",
    "Surgeon",
    "Tailor",
    "Teacher",
    "Translator",
    "Urban Planner",
    "Veterinarian",
    "Web Developer",
    "Zoologist",
];